import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import storage from '../../../components/DeviceStorage/DeviceStorage';
import Utils from '../../../utils/Utils';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class ModifyUserTask extends AbstractRequestTask {
    constructor(params = {}, method = 'GET') {
        super();
        this.method = method;
        this.ownParams = params;
        this.ownParams.user_hash = storage.getItem("user_hash") || "";

    }

    getHeaders() {
        if (this.method === 'POST') {
            return {
                'Content-Type': 'application/x-www-form-urlencoded'
            };
        }
        return super.getHeaders();
    }


    getMethod() {
        return this.method;
    }

    getParams() {
        const params = super.getParams();

        if (this.getMethod() === 'POST') {
            return {
                password: this.ownParams.password,
                email: this.ownParams.email
            }
        }
        else {
            return { ...params, ...this.ownParams };
        }

    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        const apiUrl = `${http}${url}/services/user/modify`;

        if (this.method === 'POST') {
            const { password, ...qsParams } = this.ownParams;
            const params = Utils.buildQueryParams({ ...super.getParams(), ...qsParams });
            return `${apiUrl}?${params}`;
        } else {
            return apiUrl;
        }
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }
}

export default ModifyUserTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/ModifyUserTask.js